import $ from 'jquery'
import Cookies from 'js-cookie'

Ready(function() {
  $('body').on('click', '#trumpet .close', function(e) {
    e.preventDefault()
    $('#trumpet').remove()
    Cookies.set('trumpet', 'dismissed', { expires: 1 });
  })
})
